// The URL segment under which a mission is served within its folder.
export enum MissionSpaceEnum {
  Missions = 'missions',
  Collaborations = 'collaborations',
}
